import { skipToken, useQuery } from "@tanstack/react-query";
import {
  type GetStoryPostUsageQueryResult,
  getStoriesPostUsage,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const STORY_POST_USAGE_QUERY_KEY = "STORY_POST_USAGE";

export const storyPostUsageKeys = {
  all: [STORY_POST_USAGE_QUERY_KEY],
  byIdentityUser: (activeIdentityUserPublicID?: string | null) => [
    ...storyPostUsageKeys.all,
    activeIdentityUserPublicID,
  ],
};

/**
 * The acting author's story-posting quota: the effective limit and how many stories they posted
 * in the rolling 24h window. Role-gated server-side (Admin/Merchant, same rules as posting).
 * Keyed by the active IdentityUser like the stories token — a persona switch must not show the
 * previous persona's counter.
 */
export const useStoryPostUsageQuery = (
  activeIdentityUserPublicID?: string | null,
) =>
  useQuery<GetStoryPostUsageQueryResult>({
    queryKey: storyPostUsageKeys.byIdentityUser(activeIdentityUserPublicID),
    queryFn:
      activeIdentityUserPublicID != null
        ? processResponseWithApiProblemDetails(() => getStoriesPostUsage())
        : skipToken,
    staleTime: MS_TIME.minute,
  });
